/**
 * BodyComponents passed in to a <Table> component are defined as strings.
 * (e.g. see `SystemItemTableColumns.js`)
 * Due to the string definition, the components used must be declared in the table component.
 * Those declarations are isolated to this mixin file to make the table components a little cleaner.
 */
import FormattedDate from 'components/ItemTable/BodyComponents/FormattedDate.vue';
import ItemName from 'components/ItemTable/BodyComponents/ItemName.vue';
import StatusIcon from 'components/ItemTable/BodyComponents/StatusIcon.vue';
import SystemOSIcon from 'components/ItemTable/BodyComponents/SystemOSIcon.vue';
import UserGroupListWithLink from 'components/ItemTable/BodyComponents/UserGroupListWithLink.vue';

export default {
  components: {
    FormattedDate,
    ItemName,
    StatusIcon,
    SystemOSIcon,
    UserGroupListWithLink,
  },
};
